import { handleApiResponse } from '../../handleApiResponse';
import { ApiResponseError } from '../../ApiResponseError';
import {
  CompleteUploadSessionResponse,
  CreateUploadSessionRequest,
  CreateUploadSessionResponse,
  UploadTarget,
} from './model/UploadSession';

export const createUploadSession = async (
  request: CreateUploadSessionRequest,
): Promise<CreateUploadSessionResponse> => {
  const response = await fetch(new URL('/api/v1/upload-sessions', process.env.BASE_URL || window.location.origin), {
    method: 'POST',
    headers: {
      Accept: 'application/json; charset=utf-8',
      'Content-Type': 'application/json; charset=UTF-8',
    },
    credentials: 'include',
    body: JSON.stringify(request),
  });

  handleApiResponse(response);

  return (await response.json()) as CreateUploadSessionResponse;
};

export const uploadFileToPresignedUrl = async (uploadTarget: UploadTarget, file: File): Promise<void> => {
  const response = await fetch(uploadTarget.uploadUrl, {
    method: uploadTarget.method,
    headers: uploadTarget.requiredHeaders,
    body: file,
  });

  if (!response.ok) {
    throw new ApiResponseError(response.status, response);
  }
};

export const completeUploadSession = async (sessionId: string): Promise<CompleteUploadSessionResponse> => {
  const response = await fetch(
    new URL(`/api/v1/upload-sessions/${sessionId}/complete`, process.env.BASE_URL || window.location.origin),
    {
      method: 'POST',
      credentials: 'include',
    },
  );

  handleApiResponse(response);

  return (await response.json()) as CompleteUploadSessionResponse;
};
